<template>
  <div class="welcome">
    <div class="welcome__badge">TreasureHome</div>
    <h1 class="welcome__title">{{ $t('welcome.title') }}</h1>
    <p class="welcome__subtitle">{{ $t('welcome.subtitle') }}</p>
    <button class="welcome__cta" @click="$emit('start')">
      {{ $t('welcome.cta') }}
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
    </button>
    <div class="welcome__hint">{{ $t('nav.pressEnter') }}</div>
  </div>
</template>

<script>
export default { name: 'WelcomeScreen' }
</script>

<style lang="scss" scoped>
.welcome {
  text-align: center;
  padding: 2rem 0;

  &__badge {
    display: inline-block;
    padding: 6px 18px;
    border-radius: 20px;
    background: rgba(208, 176, 146, 0.12);
    color: var(--gold-light);
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 1.5rem;
    border: 1px solid rgba(208, 176, 146, 0.15);
  }

  &__title {
    font-size: clamp(2rem, 5vw, 3.2rem);
    font-weight: 800;
    line-height: 1.1;
    margin-bottom: 1rem;
    background: linear-gradient(135deg, #fff 30%, var(--gold-light));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  &__subtitle {
    font-size: clamp(0.95rem, 2vw, 1.15rem);
    color: rgba(255, 255, 255, 0.5);
    line-height: 1.6;
    max-width: 480px;
    margin: 0 auto 2.5rem;
  }

  &__cta {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 16px 40px;
    border: none;
    border-radius: 14px;
    background: linear-gradient(135deg, var(--gold), var(--gold-dark));
    color: var(--navy);
    font-size: 1.05rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 8px 32px rgba(208, 176, 146, 0.3);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 40px rgba(208, 176, 146, 0.45);
    }
  }

  &__hint {
    margin-top: 1.5rem;
    font-size: 0.72rem;
    color: rgba(255, 255, 255, 0.15);
  }
}
</style>
